import { toBackendTrialId } from "@/utils/trialIdMap";

/**
 * Lookup key for a checked-in saved view in `./files`.
 *
 * The files are named after the *storage* trial id (`DEMO_TRIAL`), while a
 * route may still carry a display id (`DARATU-ALZ`) — the same split that
 * `FetchHook` and the feature-flag hooks already resolve with
 * `toBackendTrialId`. Resolving it here too keeps a legacy display-id URL on
 * the curated views for the trial whose data the page is actually showing.
 *
 * There is deliberately no cross-trial fallback. A trial with no file of its
 * own must miss, so the caller builds a default from that trial's own column
 * metadata: the checked-in views carry study-specific value filters (the
 * `DEMO_TRIAL` labs view pins `timepoint` to DARATU's visit schedule, and its
 * single-subject views pin `subject` to DARATU subject ids), and
 * `useCurrentWorkspace` persists whatever comes back as that trial's
 * "Default Workspace" — so an inherited view would stick.
 */
export function getDefaultViewKey(
  trialId: string,
  tableName: string,
  viewName: string = "defaultView",
): string {
  return `${toBackendTrialId(trialId)}-${tableName}-${viewName}`;
}
